import { render, staticRenderFns } from "./SmsBind.vue?vue&type=template&id=fb866c7e&"
import script from "./SmsBind.vue?vue&type=script&lang=js&"
export * from "./SmsBind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports